module.exports = "https://web-assets.ifttt.com/packs/media/docs/applet_setup2-06c32e97.png";